var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"magdc"},[_c('div',{staticClass:"magdc_d1"},[_c('div',{staticClass:"magdcd1_d1"},[_c('h3',[_vm._v(_vm._s(_vm.detail.Title))])]),_c('div',{staticClass:"magdcd1_d2",domProps:{"innerHTML":_vm._s(_vm.detail.Content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }